import { call, put, takeLatest } from 'redux-saga/effects';
import Apis from '../../../../api';
import { ConvertConstants } from '../utils';
import constantsActions from './actions';
import ConstantsTypes, { Constants } from './types';

const fetchConstantsReq = function* fetchConstantsReq() {
    try {
        const { data } = yield call(Apis.fetchConstants);
        const constants: Constants = ConvertConstants(data);
        yield put(constantsActions.setConstants(constants));
    } catch (err) {
        console.log('err:', err);
        yield put(
            constantsActions.setConstants({
                idTypes: [],
                individualAccreditation: [],
                institutionalAccreditation: [],
                nationalities: [],
                residentialStatus: [],
                countries: [],
            }),
        );
    }
};

export default function* sagas() {
    yield takeLatest(ConstantsTypes.FETCH_CONSTANTS, fetchConstantsReq);
}
